import React, { useEffect, useState } from 'react'
import { Link, useParams, } from "react-router-dom";
import { actionTypes, useStateValue } from '../../store';
import FotterMain from '../BaseComponents/FotterMain';
import Header from '../BaseComponents/Header';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { getOrderStatus } from '../../networkCalls';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';
const ResponseCheckout = () => {
  const { pageSlug } = useParams();
  const [{ token, huid }, dispatch] = useStateValue();
  const [loading, setLoading] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const pullOrderData = () => {
    var data = new FormData();
    data.append('customerId', huid);
    data.append('XAuth', token);
    data.append('TxnId', pageSlug);
    setLoading(true);
    getOrderStatus(data).then((res) => {
      //console.log('res', res.data)
      switch (res.data.status) {
        case 1:
          setOrderData(res.data?.orderData);
          setPaymentStatus(res.data?.orderStatus);
          setLoading(false);
          if(res.data?.orderStatus==1){
              localStorage.setItem("h_ct", JSON.stringify([]));
              dispatch({ type: actionTypes.SET_MINICARTITEM, value: '0' });
          }
          // dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
          // dispatch({ type: actionTypes.SET_MSGALERTDATA, value: '' });
          // dispatch({ type: actionTypes.SET_MSGALERT, value: true });
          return true;
        case 0:
          setLoading(false);
          // dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
          // dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
          // dispatch({ type: actionTypes.SET_MSGALERT, value: true });
          break;
        case 2:
          setLoading(false);
          //dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    })
  }
  useEffect(() => {
    if(token != '' && pageSlug !='' && huid !=''){
      pullOrderData();
    }
   
}, [pageSlug, token, huid, paymentStatus]);



  return (
    <>
      <Header />
      {loading ? <><LoadingCellFullPage /></> : <>
        <div className='innerpagebg pt-5 pb-5'>
          {paymentStatus && paymentStatus==1?<>  <div className='container'>
            <div className='row'>
              <div className='col-12 col-lg-9 m-auto text-center'>
                <CheckCircleOutlineIcon className='text-center mt-5 m-auto text-success f100' />
                <div className='f36 fw-bold text-center mt-2 text-success'>THANK YOU!</div>
                <div className='text-center f20 mt-3'>Your order has been received.</div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12 col-lg-5 m-auto'>
                {orderData && orderData?.length > 0 && orderData?.map((data, key) => (
                  <div className='card p-3 mb-3 mt-4 mb-4' key={data.orderId}>
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Order ID</div><div>{data?.orderId}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Dealer Name</div><div>{data?.dealerName}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Transaction ID</div><div>{data?.transactionId}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Status</div><div>{data?.status}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Order Date</div><div>{data?.orderDate}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Payment Method</div><div>{data?.paymentMode}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Payment Amount</div><div>{data?.paymentAmount}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className='row mb-5'>
              <div className='col-12 text-center'>
                <div><Link to="/" className='btn btn-danger f14'>GO HOME</Link></div>
              </div>
            </div>
          </div></>:<></>}

          {paymentStatus==2?<>  <div className='container'>
            <div className='row'>
              <div className='col-12 col-lg-9 m-auto text-center'>
              <SentimentVeryDissatisfiedIcon className='text-center mt-5 m-auto text-danger f100' />
              <div className='f20 fw-bold text-center mt-3'>Something Went Wrong</div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12 col-lg-5 m-auto'>
                {orderData && orderData?.length > 0 && orderData?.map((data, key) => (
                  <div className='card p-3 mb-3 mt-4 mb-4' key={data.orderId}>
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Order ID</div><div>{data?.orderId}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Dealer Name</div><div>{data?.dealerName}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Transaction ID</div><div>{data?.transactionId}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Status</div><div>{data?.status}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Order Date</div><div>{data?.orderDate}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Payment Method</div><div>{data?.paymentMode}</div>
                    </div>
                    <hr className='mt-2 mb-2' />
                    <div className='d-flex justify-content-between'>
                      <div className='fw-bold'>Payment Amount</div><div>{data?.paymentAmount}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className='row mb-5'>
              <div className='col-12 text-center'>
                <div><Link to="/" className='btn btn-danger f14'>GO HOME</Link></div>
              </div>
            </div>
          </div></>:<></>}
          {paymentStatus==0?<><div className='container'>
          <div className='row'>
            <div className='col-12 col-lg-9 m-auto text-center'>
              <SentimentVeryDissatisfiedIcon className='text-center mt-5 m-auto text-danger f100' />
              <div className='f20 fw-bold text-center mt-3'>Something Went Wrong</div>
            </div>
          </div>
          <div className='row mt-5'>
            <div className='col-12 text-center  mb-5'>
              <div><Link to="/" className='btn btn-danger f14'>GO HOME</Link></div>
            </div>
          </div>
        </div></>:<></>}


          
          {/* <div className='container'>
          <div className='row'>
            <div className='col-12 col-lg-9 m-auto text-center'>
              <SentimentVeryDissatisfiedIcon className='text-center mt-5 m-auto text-danger f100' />
              <div className='f20 fw-bold text-center mt-3'>Something Went Wrong</div>
            </div>
          </div>
          <div className='row mt-5'>
            <div className='col-12 text-center  mb-5'>
              <div><Link to="/" className='btn btn-danger f14'>GO HOME</Link></div>
            </div>
          </div>
        </div> */}
        </div>
      </>}

      <FotterMain />
    </>
  )
}

export default ResponseCheckout